// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18952":"c86d32fb6b34728e4f6f","25825":"6ea5000e4f80a3fbd906","80020":"72e08e137e54ef7f9435"}[chunkId] + ".css";
};